<script lang="ts" setup>
const {
  eventDetail,
  guestName,
  attendingWithText,
  isRsvpDisabled,
  formattedEventDateTime,
  formattedRsvpDeadline,
} = useRsvpSection();
</script>

<template>
  <section
    id="rsvp"
    class="px-section py-section-alt max-w-section flex flex-col gap-10 md:gap-14 lg:gap-16"
  >
    <AppSectionHeaderWrapper>
      <AppSectionTitle
        data-aos="fade-up"
        data-aos-delay="200"
      >
        RSVP
      </AppSectionTitle>

      <NuxtImg
        src="/line-primary.svg"
        data-aos="zoom-in"
        data-aos-delay="400"
        data-aos-duration="700"
        data-aos-anchor="#rsvp"
        class="w-line-graphic"
        loading="lazy"
        decoding="async"
      />
    </AppSectionHeaderWrapper>

    <div class="flex flex-col gap-8 text-center text-primary-800">
      <!-- Sapaan -->
      <p
        class="text-sm xs:text-base xl:text-lg"
        data-aos="fade"
        data-aos-delay="400"
      >
        Bapak/Ibu/Saudara/i
        <span v-if="attendingWithText">
          & {{ attendingWithText }}
        </span>
      </p>

      <ClientOnly>
        <h3
          class="text-xl font-medium xs:text-2xl md:text-3xl xl:text-4xl"
          data-aos="zoom-in"
          data-aos-delay="600"
        >
          {{ guestName }}
        </h3>

        <template #fallback>
          <USkeleton
            class="h-6 w-full bg-primary/80 rounded-md mx-auto md:max-w-sm"
          />
        </template>
      </ClientOnly>

      <div
        v-if="eventDetail"
        class="flex flex-col gap-0.5 text-sm xs:text-base xl:text-lg"
        data-aos="fade"
        data-aos-delay="500"
      >
        <p>
          Mohon konfirmasi kehadiran sebelum
        </p>

        <time
          class="font-medium"
          :datetime="formattedEventDateTime"
        >
          {{ formattedRsvpDeadline }}
        </time>
      </div>

      <div
        data-aos="zoom-in"
        data-aos-delay="600"
      >
        <PRsvpActivity
          :is-rsvp-disabled="isRsvpDisabled"
        />
      </div>
    </div>
  </section>
</template>
